import List from 'epn-ui/umd/dist/components/List';

// Helpers
import { ISupportDialogsDataAttributes } from '@api/types';
import { breakpoints } from 'src/theme';

// Components
import BaseSemanticLink from '@components/base/BaseSemanticLink';
import BaseAvatar from '@components/base/BaseAvatar';
import useWindowSize from '@hooks/useWindowSize';
import DialogMetaMobile from '../dialogMetaInfo/Mobile';
import DialogMetaDesktop from '../dialogMetaInfo/Desktop';

// Config
import { SUPPORT_AVATAR, MAX_DIALOGS_LIST_MESSAGE_LENGTH } from '../config';
import routes from '../../../../config/routes.json';

export interface IListDialogItemProps {
    item: ISupportDialogsDataAttributes;
    profileImage: string;
}

const ListDialogItem: React.FC<IListDialogItemProps> = ({ item, profileImage }) => {
    const avatarImage = item.last_from_support ? SUPPORT_AVATAR : profileImage;

    const { width: windowWidth } = useWindowSize();

    return (
        <List.Item className="!pl-4 !pr-4 hover:bg-blueGray-100 hover:cursor-pointer">
            <BaseSemanticLink
                className="flex items-center justify-between w-full"
                to={`${routes.support.dialog.replace(':id', item.id.toString())}`}
            >
                <List.Item.Meta
                    title={item.subject}
                    description={
                        <>
                            {item && item.message && (
                                <p className="p-0 m-0 overflow-ellipsis text-ellipsis">
                                    {item.message.substring(0, MAX_DIALOGS_LIST_MESSAGE_LENGTH)}
                                    {item.message.length >= MAX_DIALOGS_LIST_MESSAGE_LENGTH && (
                                        <span>...</span>
                                    )}
                                </p>
                            )}
                            <DialogMetaMobile
                                className="block xs:hidden"
                                date={item.updated_at}
                                lastFromSupport={item.last_from_support || 0}
                                isReaded={item.is_readed || 0}
                            />
                        </>
                    }
                    avatar={
                        // eslint-disable-next-line no-nested-ternary
                        windowWidth ? (
                            breakpoints.xs <= windowWidth ? (
                                <BaseAvatar
                                    className="sm:min-w-[50px] sm:w-[50px] sm:h-[50px] w-[32px] h-[32px] min-w-[32px]"
                                    src={avatarImage}
                                />
                            ) : undefined
                        ) : undefined
                    }
                />
                <DialogMetaDesktop
                    className="hidden xs:block"
                    date={item.updated_at}
                    lastFromSupport={item.last_from_support || 0}
                    isReaded={item.is_readed || 0}
                />
            </BaseSemanticLink>
        </List.Item>
    );
};

export default ListDialogItem;
